<div class="heading-container">
  <app-dashboard-header></app-dashboard-header>
</div>
<app-toast-container
  verticalPosition="bottom"
  horizontalPosition="right"
  [animate]="true"
  animationSlideDirection="left"
></app-toast-container>
<main>
  <router-outlet></router-outlet>
</main>

<footer>
  <div>
    @if (!hideAaFooter) {
      <span>Powered by&nbsp;</span
      ><a
        [href]="'https://academicanalytics.com'"
        aria-label="Go to Academic Analytics site"
        target="_blank"
        >Academic Analytics</a
      >
    }
    @if (!hideAaFooter && hasFi) {
      <i class="bullet"></i>
    }
    @if (hasFi) {
      <a
        [href]="
          'https://insight.discovery.academicanalytics.com/' +
          abbreviation?.toLowerCase()
        "
        target="_blank"
        aria-label="Go to User Login"
      >
        Faculty Login
      </a>
    }

    @if (!dashboardService.isSystem && (contactUrl || contactEmail)) {
      <i class="bullet"></i>
    }

    <!-- TODO: add contact button for system layout -->
    @if (contactUrl && !dashboardService.isSystem) {
      <a
        [href]="contactUrl"
        target="_blank"
        aria-label="Navigate to Contact Us Page"
      >
        {{ contactText ? contactText : 'Contact Us' }}
      </a>
    }
    @if (contactEmail && !dashboardService.isSystem) {
      <a [routerLink]="['/contact']" aria-label="Navigate to Contact Us Form">
        {{ contactText ? contactText : 'Contact Us' }}
      </a>
    }
  </div>
  @if (customFooterContent) {
    @for (content of customFooterContent; track content) {
      <div [innerHTML]="content" class="footer-custom"></div>
    }
  }
</footer>
